// extracted by mini-css-extract-plugin
export default {"box":"Footer_box__SPsw9","tab":"Footer_tab__i9PlS","dark":"Footer_dark__77mQU","active":"Footer_active__iaWN6"};